import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Input,
  ViewChild,
  Renderer2
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { ProjectService } from "src/app/Services/project.service";
import { MatSidenav } from "@angular/material/sidenav";
import { BehaviorSubject, Observable } from "rxjs";
import { MatMenuTrigger } from "@angular/material/menu";
import { SharedService } from "src/app/Services/sharedService";
import { HttpClient } from '@angular/common/http';
import * as M from "materialize-css/dist/js/materialize";
import { MessagingServiceService } from "src/app/Services/messaging-service.service";
import { MatDialog } from "@angular/material/dialog";
import { WelcomeComponent } from "src/app/welcome/welcome.component";
import { map } from "rxjs/operators";
import { SharedService as GlobalSharedService } from "src/app/Services/sharedService";
import { AuthService } from 'src/app/Services/auth.service';
import { WelcomeNewUserComponent } from './../../components/welcome-new-user/welcome-new-user/welcome-new-user.component';
import { ModalService } from "src/app/Services/modal.service";
import { CreateUserComponent } from "../create-user/create-user.component";
import { AddProjectComponent } from "../projects/add-project/add-project.component";
import moment from "moment";
import { TokenEncryptionService } from "src/app/Services/token-encryption.service";
import { TrialOnboardingHelpActionsService } from "src/app/Services/trial-onboarding-help-actions.service";
import { EntitlementsService } from "src/app/Services/entitlements.service";
import swal from "sweetalert2";
import { hasCompanyRole } from "src/app/utils/role.utils";
import { canManageCompanyEmployees } from "src/app/entitlements/plan-role.util";
import type { ScreenshotNotification } from "src/app/Services/sharedService";
import { PlanUpgradeDialogComponent } from "src/app/components/plan-upgrade-dialog/plan-upgrade-dialog.component";
import { sysConfig } from "src/app/sysConfig";
import { ActivationJourneyService } from "src/app/onboarding-checklist/activation-journey.service";

declare var $;
// import * as $ from "jquery";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
  standalone: false
})
export class HeaderComponent implements OnInit {
  @Input() inputSideNav: MatSidenav;
  @ViewChild("search") seachfield;
  @ViewChild('notificationTrigger') notificationTrigger: MatMenuTrigger;
  isEmployee = false;
  canManageEmployees = false;
  tabs: any = [];
  eventurl: any = [];
  empCount: any;
  iscontent = false;
  isSearchDiv = false;
  isNotification = false;
  isProfile = false;
  sideMenu = false;
  currentUser: any = {};
  adminData;
  searchData: any = [];
  filterData: any = [];
  searchQuery = '';
  sideMenuMode = 'side';
  url: string = '../../assets/search.json';
  isTourActive = 'false';
  user;
  isTeamModal = false;
  isAdmin = true;
  previousUrl: string;
  /** Employees page has its own search — hide global search to avoid dual search. */
  hideGlobalSearch = false;

  get hasSearchResults(): boolean {
    return (this.searchData || []).some((section) => this.sectionHasResults(section));
  }

  // Trial badge properties
  quotaStatus: string = '';
  daysRemaining: number = 0;
  /** True once expires_at is before the server's today_date, even if quota_status is still active. */
  isExpiryPast = false;
  showTrialBadge: boolean = false;
  dateOfExpiration: string = '';
  showTakeTourOption = false;
  isShowTryDemoBtn = false;
  isPaid = false;

  private readonly INITIALS_PALETTE = [
    '#5459D1', '#21BC68', '#FF9900', '#BC214F',
    '#2196F3', '#9C27B0', '#FF5722', '#00BCD4',
    '#607D8B', '#E91E63', '#4CAF50', '#FF6F00',
  ];

  unreadScreenshotCount = 0;
  unreadStatusCount = 0;
  totalUnreadCount = 0;
  /** True briefly when the queue count increases (badge pulse). */
  notificationBellPulse = false;
  private prevTotalQueueCount = -1;
  /** Panel shows at most this many grouped people (see groupNotificationsByEmployee). */
  readonly screenshotPanelPeopleLimit = 10;
  /** Mirrors SharedService queue cap (for tooltips / badge “50+”). */
  screenshotQueueMax = 50;

  groupedScreenshotNotifications: Array<{
    userId: number | string;
    userName: string;
    initials: string;
    color: string;
    count: number;
    latestAppName: string;
    latestCreatedAt: string;
    relativeTime: string;
    receivedAt: number;
  }> = [];

  statusNotifications: Array<{
    userId: number | string;
    userName: string;
    type: string;
    relativeTime: string;
    initials: string;
    color: string;
    receivedAt: number;
  }> = [];

  combinedActivity: any[] = [];

  constructor(
    private elementRef: ElementRef,
    private router: Router,
    private _projectService: ProjectService,
    private _modalService: ModalService,
    private dialog: MatDialog,
    private dialogService: ModalService,
    private _sharedServices: SharedService,
    private renderer: Renderer2,
    private http: HttpClient,
    private _sharedService: GlobalSharedService,
    private authService: AuthService,
    private tokenEncryptionService: TokenEncryptionService,
    public trialOnboardingHelp: TrialOnboardingHelpActionsService,
    private entitlementsService: EntitlementsService,
    private activationJourney: ActivationJourneyService
  ) {
    this.isTeamModal = false;
    if (localStorage.getItem('isTour')) {
      this.isTourActive = localStorage.getItem('isTour');
    }
    // if(localStorage.getItem('selectedData')){
    //   localStorage.removeItem('selectedData');
    // }
    let isDashboardActive = false;
    if (this.router.url == "/") {
      isDashboardActive = true;
    }
    this.previousUrl = this.router.url;
    this.tabs = [
      {
        name: "Dashboard",
        route: "/dashboard",
        icon: "dashboard",
        isActive: isDashboardActive,
      },
      {
        name: "Employees",
        route: "/employees",
        icon: "person_apron",
      },
      {
        name: "Teams",
        route: "/teams",
        icon: "groups",
      },
    ];

    if (this.router.url == this.router.url) {
      this.tabs.some((el) => {
        if (el.route == this.router.url) {
          el.isActive = true;
        }
      });
    }

    this._projectService.screencastRequest.subscribe((value) => {
      this.iscontent = value;
      if (value == false) {
        this.iscontent = false;
      }
    });
    // this.router.events.subscribe((routerEvent: NavigationEnd) => {
    //   console.log("routerEvent.url ", routerEvent.url);
    //   this.eventurl = routerEvent.url;
    // });

    this.currentUser = this.tokenEncryptionService.getEncryptedItem<any>('logedInUser') || {};
    this.adminData = this.currentUser;
  }
  searchClick() {
    if (localStorage.getItem('isTour')) {
      this.isTourActive = localStorage.getItem('isTour');
    }
    if (this.isTourActive == 'false') {
      this.isSearchDiv = true;
      this.isNotification = false;
      this.isProfile = false;
      this.searchData = this.filterData;
      this.searchData = this.search(this.searchQuery || '');
    }
  }
  ngOnInit() {
    let tour = localStorage.getItem('isTour');
    this.isShowTryDemoBtn = localStorage.getItem(this.trialOnboardingHelp.demoDashboardOptInKey) === "true";
    this._sharedServices.cleanupNotificationStorage();

    this._sharedServices.toggleMenu().subscribe((result: any) => {

      if (window.screen.width <= 1200) {
        if (tour == 'false') {
          this.sideMenuMode = 'over';
        }
      } else {
        this.sideMenuMode = 'side';
      }
    });
    if (window.screen.width <= 1200 && tour == 'false') {
      this.sideMenuMode = 'over';
    }
    else if (window.screen.width >= 1200) {
      this.sideMenuMode = 'side';
    }

    $(document).ready(function () {
      $(".dropdown-trigger").dropdown();
      // $(".dropdown-trigger").dropdown();
    });
    this.getUSer();
    this.screenshotQueueMax = this._sharedServices.screenshotNotificationQueueMax;
    this._sharedServices.unreadScreenshotCount$.subscribe((count) => {
      this.unreadScreenshotCount = count || 0;
      this.updateTotalUnread();
    });
    this._sharedServices.unreadStatusCount$.subscribe((count) => {
      this.unreadStatusCount = count || 0;
      this.updateTotalUnread();
    });
    this._sharedServices.screenshotNotifications$.subscribe((items) => {
      this.groupedScreenshotNotifications = this.groupNotificationsByEmployee(items || []);
      this.updateCombinedActivity();
    });
    this._sharedServices.statusNotifications$.subscribe((items) => {
      this.statusNotifications = (items || []).map(s => ({
        isStatusNotification: true,
        userId: s.userId,
        userName: s.userName,
        type: s.type,
        triggerTime: s.triggerTime,
        relativeTime: this.toRelativeTime(s.receivedAt),
        initials: this.getInitials(s.userName),
        color: this.getInitialsColor(s.userId),
        receivedAt: s.receivedAt
      }));
      this.updateCombinedActivity();
    });
    this.updateHideGlobalSearch(this.router.url);
    this.router.events.subscribe((route) => {
      if (route instanceof NavigationEnd) {
        this.isSearchDiv = false;
        this.previousUrl = (route as NavigationEnd).url;
        this.updateHideGlobalSearch((route as NavigationEnd).urlAfterRedirects || (route as NavigationEnd).url);
      }
    })
  }

  private updateHideGlobalSearch(url: string): void {
    const path = (url || '').split('?')[0];
    this.hideGlobalSearch = path === '/employees' || path.startsWith('/employees/');
  }
  getJsonList() {
    if (localStorage.getItem('isAdmin')) {
      if (localStorage.getItem('isAdmin') == 'true') {
        this.url = '../../assets/search.json';
      } else {
        this.url = '../../assets/seachManager.json';
      }
    } else {
      this.url = '../../assets/search.json';
    }
    this.http.get(this.url).subscribe(res => {
      this.searchData = res;
      this.filterData = res;
      this.getDevList()
      this.getTeam()
    });
  }
  getUSer() {
    let roleArr = [];
    this._projectService.getUser().subscribe((data: any) => {
      this.tokenEncryptionService.setEncryptedItem('user', data);
      let isExpired = this._sharedService.checkPlanExpired(data)
      if (isExpired) {
        this.router.navigateByUrl('/plan-expired');
      }
      roleArr = data.role;
      this.user = data;
      this.isAdmin = hasCompanyRole(data);
      this.canManageEmployees = canManageCompanyEmployees(data);
      this.isPaid = data.meta.quota_status === 'active' || data.meta.quota_status === 'Active';
      // this.showTakeTourOption = this.isAdmin;
      localStorage.setItem('isAdmin', this.isAdmin ? 'true' : 'false');

      // Update adminData with latest user data to ensure company name is properly displayed
      this.adminData = { ...data };
      // Store user data for getDisplayName method
      this.user = data;

      // Calculate trial badge data
      this.quotaStatus = data.meta.quota_status;
      if (data.meta.expires_at) {
        this.calculateDaysRemaining(data.meta.expires_at, data.meta.today_date);
        this.dateOfExpiration = moment(data.meta.expires_at).format('DD MMM YYYY');
      }
      // Hide renewal notices if subscription auto-renews
      const subscriptionStatus = (data.meta.subscription_status || '').toLowerCase();
      // Show trial badge for trial status, expiring soon, or expired plans
      const isBannerClosed = sessionStorage.getItem('isTrialBanner');
      if (this.isAdmin && subscriptionStatus !== 'active') {
        if (this.quotaStatus === 'trial' || this.quotaStatus === 'Trial') {
          this.showTrialBadge = true;
        } else if ((this.quotaStatus === 'active' || this.quotaStatus === 'Active') && this.daysRemaining <= data.meta.adv_pay) {
          this.showTrialBadge = true;
        } else if (this.quotaStatus === 'expired' || this.quotaStatus === 'Expired' ||
          this.quotaStatus === 'trial-expired' || this.quotaStatus === 'Trial-expired') {
          this.showTrialBadge = true;
        }
      }

      this.getJsonList();
    })
  }

  /**
   * Get the display name for the user, prioritizing company name for admins
   * @returns Full display name
   */
  getDisplayName(): string {
    if (!this.adminData && !this.user) {
      return '';
    }

    // For company admins, prioritize company name from meta
    // Check both user (from getUser) and adminData for company name
    const userData = this.user || this.adminData;
    if (this.isAdmin && userData && userData.meta && userData.meta.company_name) {
      const companyName = userData.meta.company_name.trim();
      if (companyName && companyName !== 'undefined' && companyName !== 'null') {
        return companyName;
      }
    }

    // Fallback to user_display_name or name
    const displayName = this.adminData?.user_display_name || this.adminData?.name || this.user?.user_display_name || this.user?.name || '';

    // If display name appears truncated (only 2 words), try to get full company name
    if (displayName && displayName.split(' ').length <= 2 && this.isAdmin && userData?.meta?.company_name) {
      const companyName = userData.meta.company_name.trim();
      if (companyName && companyName !== 'undefined' && companyName !== 'null' && companyName.split(' ').length > 2) {
        return companyName;
      }
    }

    return displayName;
  }

  calculateDaysRemaining(strDate: string, strToday: string) {
    const expirationDate = new Date(strDate);
    const today = new Date(strToday);
    const timeDifference = expirationDate.getTime() - today.getTime();
    if (Number.isNaN(timeDifference)) {
      this.daysRemaining = 0;
      this.isExpiryPast = false;
      return;
    }
    // quota_status can stay "active" for a while after the end date. Keep the
    // signed day count for the renew window, and flag a past date separately
    // so the badge never prints a negative countdown.
    this.isExpiryPast = timeDifference < 0;
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
    this.daysRemaining = Math.round(daysDifference);
  }

  /** Ended plans use the red chip, including when the API status has not flipped yet. */
  get planCountdownEnded(): boolean {
    const status = (this.quotaStatus || '').toLowerCase();
    return status === 'expired' || status === 'trial-expired' || this.isExpiryPast;
  }

  get expiryBadgeText(): string {
    const status = (this.quotaStatus || '').toLowerCase();
    const dayLabel = this.daysRemaining === 1 ? 'Day' : 'Days';

    if (status === 'expired' || (status === 'active' && this.isExpiryPast)) {
      return `Plan Expired on ${this.dateOfExpiration}`;
    }
    if (status === 'trial-expired' || (status === 'trial' && this.isExpiryPast)) {
      return `Trial Expired on ${this.dateOfExpiration}`;
    }
    if (status === 'trial') {
      if (this.daysRemaining <= 0) {
        return 'Trial expires today';
      }
      return `Trial expires in ${this.daysRemaining} ${dayLabel}`;
    }
    if (status === 'active') {
      if (this.daysRemaining <= 0) {
        return 'Plan expires today';
      }
      return `Plan expires in ${this.daysRemaining} ${dayLabel}`;
    }
    return '';
  }

  navigateToBilling() {
    // In-app routing to Billing freezes a trial company on the page they
    // clicked from. A full load is the path that paints Billing.
    window.location.assign('/billings');
  }
  logoutCall() {
    this.authService.performLogout();
  }

  @HostListener("document:click")
  onClick($event: HTMLElement) {
    // if($('.notificationDiv').hasClass('hidediv') == false){
    // $('.notificationDiv').addClass('hidediv');
    // }
    const eventTarget = this.elementRef.nativeElement.contains(event.target);
    if (!eventTarget) {
      this.isSearchDiv = false;
      this.isNotification = false;
      this.isProfile = false;
    }
  }
  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closeSearch();
      this.isNotification = false;
      this.isProfile = false;
    }
  }
  toggleSideMenu() {
    if (this.sideMenu == false) {
      this.sideMenu = true;
    } else {
      this.sideMenu = false;
    }
    this._sharedService.sideMenuSubject.next(this.sideMenu);
  }

  /** Badge label: show "50+" when queue is at capacity. */
  get screenshotBadgeLabel(): string {
    const n = this.totalUnreadCount;
    if (n <= 0) return "";
    const max = this.screenshotQueueMax;
    if (n >= max) return `${max}+`;
    return String(n);
  }

  screenshotRowTooltip(n: {
    userName: string;
    count: number;
    latestAppName: string;
    relativeTime: string;
  }): string {
    const parts = `${n.count} screenshot${n.count !== 1 ? "s" : ""}`;
    return `${n.userName} — ${parts}, latest: ${n.latestAppName} (${n.relativeTime})`;
  }

  onNotificationsOpened() {
    this.isSearchDiv = false;
    this.isProfile = false;
    this.isNotification = false;
  }

  onNotificationRowKeydown(event: KeyboardEvent, userId: number | string) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.openEmployee(userId);
    }
  }

  navigateToScreenshots() {
    this.router.navigate(["/screenshots"]);
    if (this.notificationTrigger) {
      this.notificationTrigger.closeMenu();
    }
  }

  clearNotifications() {
    this._sharedServices.clearAllNotifications();
  }

  openEmployee(userId: number | string) {
    if (userId === null || userId === undefined) return;
    this.router.navigate([`/user-details/${userId}`]);
    if (this.notificationTrigger) {
      this.notificationTrigger.closeMenu();
    }
  }

  private groupNotificationsByEmployee(items: ScreenshotNotification[]) {
    const byUser = new Map<string, ScreenshotNotification[]>();
    for (const n of items) {
      const key = String(n.userId);
      const arr = byUser.get(key) || [];
      arr.push(n);
      byUser.set(key, arr);
    }

    const grouped = Array.from(byUser.entries()).map(([key, arr]) => {
      const sorted = arr.slice().sort((a, b) => (b.receivedAt || 0) - (a.receivedAt || 0));
      const latest = sorted[0];
      return {
        userId: latest.userId,
        userName: latest.userName,
        initials: this.getInitials(latest.userName),
        color: this.getInitialsColor(latest.userId),
        count: sorted.length,
        latestAppName: latest.appName || "—",
        latestCreatedAt: latest.createdAt,
        relativeTime: this.toRelativeTime(latest.receivedAt),
        receivedAt: latest.receivedAt
      };
    });

    grouped.sort((a, b) => {
      const ta = new Date(a.latestCreatedAt).getTime();
      const tb = new Date(b.latestCreatedAt).getTime();
      return (Number.isFinite(tb) ? tb : 0) - (Number.isFinite(ta) ? ta : 0);
    });

    return grouped.slice(0, 10);
  }

  private updateCombinedActivity() {
    const screenshots = this.groupedScreenshotNotifications.map(n => ({ ...n, activityType: 'screenshot' }));
    const statuses = this.statusNotifications.map(s => ({ ...s, activityType: 'status' }));

    this.combinedActivity = [...screenshots, ...statuses].sort((a, b) => (b.receivedAt || 0) - (a.receivedAt || 0));
  }

  private updateTotalUnread() {
    const current = this.unreadScreenshotCount + this.unreadStatusCount;
    if (this.prevTotalQueueCount >= 0 && current > this.prevTotalQueueCount) {
      this.notificationBellPulse = true;
      setTimeout(() => {
        this.notificationBellPulse = false;
      }, 320);
    }
    this.prevTotalQueueCount = current;
    this.totalUnreadCount = current;
  }

  private getInitials(name: string): string {
    const n = (name || "").trim();
    if (!n) return "?";
    const parts = n.split(/\s+/).filter(Boolean);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0].slice(0, 1) + parts[parts.length - 1].slice(0, 1)).toUpperCase();
  }

  private getInitialsColor(userId: number | string): string {
    const hash = String(userId).split('').reduce((acc, c) => acc + c.charCodeAt(0), 0);
    return this.INITIALS_PALETTE[hash % this.INITIALS_PALETTE.length];
  }

  private toRelativeTime(tsMs: number): string {
    if (!tsMs) return "";
    const diffSec = Math.floor((Date.now() - tsMs) / 1000);
    if (diffSec < 5) return "just now";
    if (diffSec < 60) return `${diffSec} seconds ago`;
    const diffMin = Math.floor(diffSec / 60);
    if (diffMin < 60) return `${diffMin} minutes ago`;
    const diffHr = Math.floor(diffMin / 60);
    if (diffHr < 24) return `${diffHr} hours ago`;
    const diffDay = Math.floor(diffHr / 24);
    if (diffDay === 1) return "1 day ago";
    return `${diffDay} days ago`;
  }

  openModal(actionType) {
    this.closeSearch();
    this._projectService.getUser().subscribe(
      (data: any) => {
        const isExpired = this.expiringDate(data.meta.expires_at);
        console.log("create user modal", actionType.isExpired, data.meta.expires_at)
        if (isExpired == false) {
          if (actionType == 'team') {
            this.entitlementsService.syncFromSession();
            if (!this.entitlementsService.canCreateTeam()) {
              const ref = this.dialog.open(PlanUpgradeDialogComponent, {
                width: '420px',
                maxWidth: '94vw',
                data: {
                  title: 'Team limit reached',
                  message: this.entitlementsService.getTeamLimitMessage(),
                },
              });
              ref.afterClosed().subscribe((confirmed) => {
                if (confirmed) {
                  void this.router.navigate(['/billings'], { queryParams: { intent: 'upgrade' } });
                }
              });
              return;
            }
            this.isTeamModal = true;
            this.openCreateTeamModal();
          } else if (actionType == 'employee') {
            if (!canManageCompanyEmployees(this.user)) {
              void swal.fire({
                icon: 'info',
                title: 'Not allowed',
                text: 'Team leads cannot add or edit employees.',
              });
              return;
            }
            if (this.user.meta.quota_remaining != false || this.user.meta.quota_remaining != 'false') {
              this.openCreateUserModal();
            }
          }
        }
      })
  }

  openCreateUserModal() {
    if (this._modalService.isAlreadyOpenDialog(CreateUserComponent)) {
      this._modalService.closeDialogIfOpen(CreateUserComponent);
    }
    this._modalService.openCommonMatDialog(
      CreateUserComponent,
      {
        className: 'create-user-modal',
        maxHeight: '80vh',
        disableClose: false,
        componentData: { isUserEditable: false, editUserId: null },
        // position: { top: '30px' }
      }
    );
  }

  openCreateTeamModal() {
    if (this._modalService.isAlreadyOpenDialog(AddProjectComponent)) {
      this._modalService.closeDialogIfOpen(AddProjectComponent)
    }

    this._modalService.openCommonMatDialog(AddProjectComponent, {
      className: 'add-project-modal',
      disableClose: false,
      maxHeight: '90vh',
      // position: {
      //   top: '30px'
      // }
    })
  }

  scrollToDashboardSection(actionType) {
    this.router.navigate(["/dashboard"]);
    this._sharedService.dashboardScrollerSubject.next(actionType);
    this.closeSearch();
  }

  /** Deep-link Settings tabs via ?tab= (capture|tracking|schedule|delivery|bulk). */
  openSettingsTab(tab: string) {
    this.closeSearch();
    this.router.navigate(['/employee/setting'], { queryParams: { tab } });
  }

  /** @deprecated Prefer openSettingsTab — kept for any leftover callers. */
  scrollToSettingSection(actionType) {
    this.openSettingsTab(actionType);
  }

  closeSearch() {
    this.isSearchDiv = false;
    this.searchQuery = '';
    this.isEmployee = false;
    this.searchData = this.filterData;
    if (this.seachfield?.nativeElement) {
      this.seachfield.nativeElement.value = '';
    }
  }

  sectionHasResults(section: any): boolean {
    if (!section) {
      return false;
    }
    if (!this.searchQuery && section.show_in_browse === false) {
      return false;
    }
    const items = section.items || [];
    const data = section.data || [];
    if (section.section_type === 'Employee' || section.section_type === 'Teams') {
      return this.isEmployee && data.length > 0;
    }
    return items.length > 0;
  }

  onKey(value?: any) {
    const query = (value || '').toString();
    this.searchQuery = query.trim();
    this.searchData = this.filterData;
    this.isEmployee = this.searchQuery.length > 0;
    this.searchData = this.search(this.searchQuery);
  }

  search(value: string) {
    const filter = (value || '').toLowerCase();
    const browsing = !filter;
    return this.searchData.map(section => {
      const allowItem = (item: any) => {
        if (browsing && item?.show_in_browse === false) {
          return false;
        }
        if (!filter) {
          return true;
        }
        const name = (item.action_name || '').toLowerCase();
        const sub = (item.subtitle || '').toLowerCase();
        return name.includes(filter) || sub.includes(filter);
      };

      if (section.section_type == "Employee") {
        return {
          section_type: section.section_type,
          show_in_browse: section.show_in_browse,
          items: (section.items || []).filter(allowItem),
          data: (section.data || []).filter(res =>
            (res.name || '').toLowerCase().includes(filter))
        };
      }
      if (section.section_type == "Teams") {
        return {
          section_type: section.section_type,
          show_in_browse: section.show_in_browse,
          items: (section.items || []).filter(allowItem),
          data: (section.data || []).filter(res =>
            (res.title?.rendered || '').toLowerCase().includes(filter))
        };
      }
      return {
        section_type: section.section_type,
        show_in_browse: section.show_in_browse,
        items: (section.items || []).filter(allowItem)
      };
    });
  }
  getDevList() {
    this._projectService
      .getUserList(0, 0)
      .subscribe((user: any) => {
        this.searchData.filter(section =>
          section.section_type === 'Employee').map((item: any) => item["data"] = user)
        this.filterData.filter(section =>
          section.section_type === 'Employee').map((item: any) => item["data"] = user)
      })
  }

  getTeam() {
    this._projectService.getTeamList().subscribe(
      (team: any) => {
        this.searchData.filter(section =>
          section.section_type === 'Teams').map((item: any) => item["data"] = team)
        this.filterData.filter(section =>
          section.section_type === 'Teams').map((item: any) => item["data"] = team)
        // this.teamList = team;
      },
      (err) => {
      }
    );
  }

  userDetail(id) {
    this.closeSearch();
    this.router.navigate([`/user-details/${id}`]);
    this.getJsonList();
  }

  async openTeamPage(data) {
    this.closeSearch();
    localStorage.setItem('selectedData', JSON.stringify(data));
    this.router.navigate([`/teams`]);
    this._projectService.updateSelectedTeamData({ data: data });
    this.getJsonList();
  }

  openTeamsList() {
    if (localStorage.getItem('selectedData')) {
      localStorage.removeItem('selectedData');
    }
    this.closeSearch();
    this.router.navigate(['/teams']);
    this.getJsonList();
  }

  /** @deprecated Prefer openTeamsList */
  moveTeamList() {
    this.openTeamsList();
  }

  startTour() {
    this.openDialog();
    localStorage.setItem('tourStart', 'true');
  }

  resumeSetupFromHeader(): void {
    this.isProfile = false;
    this.trialOnboardingHelp.resumeSetup();
  }

  /** Profile menu: open activation Journey anytime (when the feature flag is on). */
  get showJourneyMenuItem(): boolean {
    return this.isAdmin && !!sysConfig.activationJourneyEnabled;
  }

  openJourneyFromHeader(): void {
    this.isProfile = false;
    if (!sysConfig.activationJourneyEnabled) {
      return;
    }
    const state = this.activationJourney.getState();
    this.activationJourney.trackEvent('journey_opened_from_menu', {
      journeyStatus: state.journeyStatus,
      currentStep: state.currentStep,
    });
    // Menu is a fresh walk. Reset the wizard cursor only (employees, screenshots,
    // and the installed app stay). from=menu lets a finished account into /setup.
    this.activationJourney.beginIntentionalReentry('menu');
    const openReady = () => {
      void this.router.navigate(['/setup/ready'], { queryParams: { from: 'menu' } });
    };
    this.activationJourney.resetFromServer().subscribe({
      next: openReady,
      error: () => {
        this.activationJourney.reset();
        openReady();
      },
    });
  }

  tryDemoDataFromHeader(): void {
    this.isProfile = false;
    const currentState = this.trialOnboardingHelp.isShowingDemoData();
    this.trialOnboardingHelp.tryDemoData(!currentState);
  }

  openDialog() {
    this.dialogService.openCommonMatDialog(WelcomeNewUserComponent, {
      className: 'welcomeUser-dialog',
      maxHeight: '90vh',
      disableClose: false,
      componentData: {
        takeTour: true
      }
    })
    // this.dialogService.open(WelcomeNewUserComponent, {
    //   panelClass: 'welcomeUser-dialog',
    //   maxHeight: '90vh',
    //   disableClose: true,
    //   data: {
    //     takeTour: true
    //   }
    // })
    localStorage.setItem('isOpenedWelcomeDialog', 'true');
  }

  moveToDownload() {
    window.open('https://supersee.io/download');
  }

  expiringDate(strDate: string): boolean {
    const expirationDate = moment(strDate);
    const currentDate = moment();

    const diffInDays = expirationDate.diff(currentDate, 'days');

    console.log(diffInDays)

    return diffInDays <= 0;
  }

  moveToBillingInvoices() {
    this.router.navigate([`/billings`]);
    this.isProfile = false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {

    if (window.screen.width <= 1200) {
      this.sideMenuMode = 'over';
    } else if (window.screen.width > 1200) {
      this.sideMenuMode = 'side';
    }
  }
}
